import * as React from "react";
import { Heading } from "@grandvisionhq/elements";
import { Spinner, Alert } from "@grandvisionhq/iris-ui";
import { useIntl, useDispatch } from "@grandvisionhq/state";
import { useAppointments } from "../../../hooks/Appointments/hooks/useAppointments.js";
import AppointmentBody from "../../components/AppointmentBody/Appointments/List/components/AppointmentBody/AppointmentBody.js";
import { appointmentsView } from "../../../../data-layer/appointments/data-layer/appointments/actions.js";
const AppointmentsContainer = () => {
  const { getLabel, getFormattedLabel } = useIntl();
  const dispatch = useDispatch();
  const { data: appointments, loading, error } = useAppointments();
  const routeLabel = getLabel(`account.menu.appointments`);
  React.useEffect(() => {
    if (loading || appointments === null) {
      return;
    }
    dispatch(appointmentsView(appointments));
  }, [appointments, dispatch, loading]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Heading, { variant: "small" }, routeLabel), loading ? /* @__PURE__ */ React.createElement(Spinner, { "aria-label": getLabel("common.loadingText") }) : error || appointments === null ? (
    // not loading but has error
    /* @__PURE__ */ React.createElement(Alert, { variant: "error", className: "alert-m-default" }, getFormattedLabel("common.error.network"))
  ) : (
    // not loading and no error
    /* @__PURE__ */ React.createElement(AppointmentBody, { appointments })
  ));
};
export {
  AppointmentsContainer as default
};
//# sourceMappingURL=Appointments.js.map
